import { IS_DEV_ENV } from "constants/isDevEnv";

interface FeatureFlagsByOrchidPro {
  dontPreselectAppointmentType: boolean;
  useFastTranscriptionForUploadedRecordings: boolean;
}

const getFeatureFlagsByOrchidPro = (
  orchidPro?: OrchidPro,
): FeatureFlagsByOrchidPro => {
  if (IS_DEV_ENV) {
    return {
      dontPreselectAppointmentType:
        orchidPro?.cognito_sub === "4f3dae01-327c-453f-a88d-b700e0920542", // Adadddd Pdoctor, MC
      useFastTranscriptionForUploadedRecordings: true,
    };
  }

  return {
    dontPreselectAppointmentType:
      orchidPro?.cognito_sub === "f5bb5d93-0acd-4e45-a172-b6e41d166799", // Daniel Block, MD
    // useFastTranscriptionForUploadedRecordings:
    // orchidPro?.cognito_sub === "2d34f3c7-6bda-4c44-b11c-f31ec1cea41c", //aya.gungun.banana+999@gmail.com
    useFastTranscriptionForUploadedRecordings: true,
  };
};

export default getFeatureFlagsByOrchidPro;
